import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Timestamp from './Timestamp'
import {getActivityTimestamp} from 'shared/utils/time'

import iconButtons from 'assets/icons/icon-action-buttons.svg'
import iconCard from 'assets/icons/icon-action-card.svg'
import iconCarousel from 'assets/icons/icon-action-carousel.svg'
import iconList from 'assets/icons/icon-action-list.svg'
import iconEvent from 'assets/icons/icon-action-event.svg'
import iconAction from 'assets/icons/icon-action-actions.svg'

import InlineSVG from 'svg-inline-react'

const WidgetTitle = styled.p`
  color: #FFFFFF;
  text-transform: capitalize;
  font-size: 14rem;
  text-align: center;
`

const WidgetContainer = styled.div`
  padding: 16px; 
  margin-top: ${props => props.endOfBlock ? '16px' : '4px' };
  border-radius: 8px;
  width: 100px;
  height: 100px;
  
  font-size: 14rem;
  text-align: center;  
  text-transform: capitalize;
  
  align-self: ${props => props.isLeft ? 'flex-start' : 'flex-end'};
  position: relative;
  cursor: default;
  
  border: 2px solid rgba(144, 161, 176, 0.32);  
  background-color: rgba(144, 161, 176, 0.5); 
`

const SimpleWidget = ({ type, payload, endOfBlock, avatar, isLeft, createdAt }) => {
  const renderIcon = () => {
    switch(type){
      case 'nothing':
      case 'action': return iconAction
      case 'card': return iconCard
      case 'buttons': return iconButtons
      case 'carousel': return iconCarousel
      case 'list': return iconList
      case 'event': return iconEvent
      default: return null
    }
  }
  const icon = renderIcon()
  const title = (type === 'event' || type === 'action') ? `${type}: ${payload.label || payload.name}` : `${type}`

  return(
    <WidgetContainer
      isLeft={isLeft}
      avatar={avatar}
      endOfBlock={endOfBlock}
    >
      <Timestamp stampType='small' time={createdAt} />
      <WidgetTitle>{title}</WidgetTitle>
      { icon && <InlineSVG src={icon}/>}
    </WidgetContainer>
  )
}

SimpleWidget.defaultProps = {
  isLeft: false
}

SimpleWidget.propTypes = {
  type: PropTypes.string.isRequired,
  payload: PropTypes.object.isRequired,
  avatar: PropTypes.any,
  endOfBlock: PropTypes.bool,
  isLeft: PropTypes.bool,
  createdAt: PropTypes.instanceOf(Date).isRequired
}

export default SimpleWidget